import { getColumnBandClass, getGapSplitStyle } from '../utils'
import StoryCell from './StoryCell'
import styles from '../../ProjectStoryMapBoard.module.css'

const NoStepStoryCell = ({ release, track, trackIndex, boardTracks }) => {
    const bandClass = getColumnBandClass(boardTracks, trackIndex, styles)

    return (
        <div
            key={`${release.id}-${track.type}-${trackIndex}`}
            className={`${styles.stepColumn} ${bandClass}`}
        >
            <div className={styles.noStepStoryCell}>
                <p className={styles.noStepStoryMsg}>
                    You must add a step to this journey before you can add stories.
                </p>
            </div>
        </div>
    )
}

const StoryGapCell = ({ release, track, trackIndex, boardTracks }) => {
    const gapSplitStyle = getGapSplitStyle(boardTracks, trackIndex, styles)

    return (
        <div
            key={`${release.id}-${track.type}-${trackIndex}`}
            className={`${styles.columnGap} ${styles.columnGapSplit}`}
            style={gapSplitStyle}
            aria-hidden
        />
    )
}

const StoryColumns = ({
    release,
    boardTracks,
    onAddStory,
    onOpenStory,
    editingStoryId,
    editingStoryDraft,
    storyInputRef,
    onStoryDraftChange,
    onCommitStoryTitle,
    storyMenu,
    highlightedCardId,
    isFilterActive = false,
    filterFocusedCardId = null,
    storyDragOverCellKey = null,
    isStoryDragging = false,
    readOnly = false,
}) =>
    boardTracks.map((track, trackIndex) => {
        if (track.type === 'step') {
            const cellKey = `${release.id}|${track.step.id}`
            return (
                <StoryCell
                    key={`${release.id}-${track.step.id}`}
                    release={release}
                    step={track.step}
                    trackIndex={trackIndex}
                    boardTracks={boardTracks}
                    onAddStory={onAddStory}
                    onOpenStory={onOpenStory}
                    editingStoryId={editingStoryId}
                    editingStoryDraft={editingStoryDraft}
                    storyInputRef={storyInputRef}
                    onStoryDraftChange={onStoryDraftChange}
                    onCommitStoryTitle={onCommitStoryTitle}
                    storyMenu={storyMenu}
                    highlightedCardId={highlightedCardId}
                    isFilterActive={isFilterActive}
                    filterFocusedCardId={filterFocusedCardId}
                    isPointerDropTarget={
                        storyDragOverCellKey != null &&
                        storyDragOverCellKey === cellKey
                    }
                    isStoryDragging={isStoryDragging}
                    readOnly={readOnly}
                />
            )
        }

        if (track.type === 'emptyStep') {
            return (
                <NoStepStoryCell
                    key={`${release.id}-${track.type}-${trackIndex}`}
                    release={release}
                    track={track}
                    trackIndex={trackIndex}
                    boardTracks={boardTracks}
                />
            )
        }

        return (
            <StoryGapCell
                key={`${release.id}-${track.type}-${trackIndex}`}
                release={release}
                track={track}
                trackIndex={trackIndex}
                boardTracks={boardTracks}
            />
        )
    })

export default StoryColumns
